import { KeyboardEvent, TouchEvent, useEffect } from 'react'

export const useWindowEvent = (
  eventName: keyof WindowEventMap,
  callback: (event: KeyboardEvent | TouchEvent) => void,
  options?: Parameters<typeof window.addEventListener>[2]
) => {
  useEffect(() => {
    window.addEventListener(eventName as any, callback as any, options as any)
    return () => {
      window.removeEventListener(
        eventName as any,
        callback as any,
        options as any
      )
    }
  }, [eventName, callback, options])
}
